import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getLeadAppointmentsAPI = createAsyncThunk(
  "lead/getLeadAppointmentsAPI",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/leads/appointments/`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return resp?.data;
    } catch (error) {
      if (error.mesage) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
